<template>
    <div class="aid-container">
        <h4>Interactions hinzufügen</h4>
        <div class="grey-container">
            <div class="top-bar">
                <InputSearch placeholder="Suche" v-model="searchValue" width="230px"></InputSearch>
                <Checkbox @change="onFilterChanged('Online')" v-model="checked['Online']" id="filter-in-progress"
                          title="Online"></Checkbox>
                <Checkbox @change="onFilterChanged('Desktop')" v-model="checked['Desktop']" id="filter-in-progress"
                          title="Desktop"></Checkbox>
                <Checkbox @change="onFilterChanged('Mobile')" v-model="checked['Mobile']" id="filter-checked"
                          title="Mobile"></Checkbox>
                <Checkbox @change="onFilterChanged('Tablet')" v-model="checked['Tablet']" id="filter-checked"
                          title="Tablet"></Checkbox>
                <AdaButton style="margin-left: auto" title="REFRESH" type="createButton blue"
                           @click="refresh()"></AdaButton>
            </div>
            <AdaDatatable v-if="!loading" style="margin-bottom: 20px" :columns="columns" :data="interactions"
                          :disable-pagination="true"
                          :show-search="false" :table-filters="[this.tableFilter]"
                          :size-of-page="10000"
                          @rowClicked="cellClicked" :search-value="searchValue" :scroll="true"
                          :transformers="transformers"></AdaDatatable>
            <div v-if="loading" class="loaderContainer">
                <dot-loader id="loader"></dot-loader>
            </div>
            <AdaButton title="HINZUFÜGEN" type="createButton" @click="addClicked"
                       style="width: fit-content"></AdaButton>
        </div>
    </div>
</template>

<script>
    import AdaButton from "../../../components/buttons/AdaButton";
    import Transformers from "../../../components/tables/Transformers";
    import AdaDatatable from "../../../components/tables/AdaDatatable";
    import Checkbox from "../../../components/inputs/Checkbox";
    import InputSearch from "../../../components/inputs/InputSearch";

    export default {
        components: {
            AdaButton,
            AdaDatatable,
            Checkbox,
            InputSearch
        },
        props: {
            initialInteractions: {
                required: false,
                default: () => []
            }
        },
        data: function () {
            return {
                loading: false,
                checked: {
                    "Online": false,
                    "Desktop": false,
                    "Mobile": false,
                    "Tablet": false
                },
                searchValue: '',
                selectedInteractions: [],
                tableFilter: {
                    propName: 'medium',
                    allowedValues: [],
                    mode: 'OR'
                },
                columns: [
                    {
                        viewName: 'Interaktion',
                        propName: 'name',
                        sortable: true,
                        width: '30%'
                    },
                    {
                        viewName: 'Technischer Name',
                        propName: 'technical_name',
                        sortable: true,
                        width: '30%'
                    },
                    {
                        viewName: 'Medium',
                        propName: 'medium',
                        width: '20%'
                    },
                    {
                        viewName: 'Erstellungsdatum',
                        propName: 'created_at',
                        sortable: true,
                        width: '20%'
                    }
                ],
                activeItemName: 'Interaktionen',
                transformers: [
                    {
                        propName: 'name',
                        transform: function (value, row) {
                            let checked = '';
                            let disabled = '';
                            if (row.selected) {
                                checked = ' checked disabled';
                            }
                            if (row.disabled) {
                                disabled = ' disabled';
                            }
                            let res = '<div style="cursor: pointer; user-select: none"><input style="cursor: pointer" id="'
                                + row.id + '" data-type="select" type="checkbox"' + checked + disabled + '> <label style="cursor: pointer">' + value + '</label></div>';
                            return res;
                        }
                    },
                    {
                        propName: 'created_at',
                        transform: Transformers.dateTransformer
                    },
                    {
                        propName: 'medium',
                        transform: Transformers.interactionMediumTransformer
                    }
                ],
            }
        },
        name: "SelectInteractionsFromTable",
        mounted() {
            this.fetchInteractions();
        },
        computed: {
            interactions() {
                const data = this.$store.state.interactions.interactionTemplates;
                for (let i = 0; i < data.length; i++) {
                    data[i].selected = false;
                    data[i].disabled = false;
                }
                data.forEach(inter => {
                    this.initialInteractions.forEach(initial => {
                        if (inter.id === initial.id) {
                            inter.selected = true;
                            inter.disabled = true;
                            this.selectedInteractions.push(inter);
                            if (initial.original) {
                                inter.disabled = true;
                            }
                        } else if (typeof inter.selected === 'undefined') {
                            inter.selected = false;
                            inter.disabled = false;
                        }
                    })
                });
                return data;
            }
        },
        methods: {
            refresh() {
                this.fetchInteractions();
            },
            onFilterChanged: function (type) {
                let allowedValues = [];
                if (type !== 'Online') {
                    this.checked['Online'] = false;
                }
                for (let key in this.checked) {
                    if (this.checked[key]) {
                        allowedValues.push(key);
                    }
                }
                if (this.checked['Online']) {
                    allowedValues = [
                        "Desktop",
                        "Tablet"
                    ];
                    this.checked['Desktop'] = false;
                    this.checked['Mobile'] = false;
                    this.checked['Tablet'] = false;
                    this.tableFilter.mode = 'AND';
                } else {
                    this.tableFilter.mode = 'OR';
                }
                this.tableFilter.allowedValues = allowedValues;
            },
            cellClicked: function (data) {
                data.row.selected = !data.row.selected;
                for (let i = 0; i < this.interactions.length; i++) {
                    if (this.interactions[i].id === data.row.id) {
                        if (!document.getElementById(data.row.id).disabled) {
                            this.interactions[i].selected = data.row.selected;
                            document.getElementById(data.row.id).checked = data.row.selected;
                        }
                    }
                }
            },
            async fetchInteractions() {
                this.loading = true;
                await this.$store.dispatch('interactions/fetchInteractionTemplates', true);
                this.loading = false;
            },
            addClicked() {
                const selectedInteractions = this.getSelectedInteractions();
                this.$emit('selected', selectedInteractions);
            },
            getSelectedInteractions() {
                return this.interactions.filter(inter => inter.selected);
            }
        }
    }
</script>

<style lang="scss" scoped>

    h4 {
        margin-top: 0;
    }

    .top-bar {
        background-color: white;
        padding: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .inter-xxl {
        width: 250px;
        margin-right: 16px;
        margin-bottom: 16px;
    }

    .small-headline-container {
        display: flex;
        flex-direction: row;
        margin-bottom: 30px;
        font-size: 10px;
    }

    .small-headline {
        color: $grey;
    }

    hr {
        margin-left: 6px;
        color: black;
        border: solid $grey 1px;
        height: 1px;
        width: 100%;
    }

    .aid-container {
        padding: 0 10px 10px 10px;
        width: 100%;
    }

    .grey-container {
        background-color: $lightGrey;
        padding: 16px;
    }

    .interactions-container {
        max-height: 40vh;
        overflow-y: scroll;
        margin-bottom: 30px;
    }

    .loaderContainer {
        height: 40vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .interactions-container {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
    }

    ::v-deep tbody tr td:nth-child(3) {
        padding: 0 20px;

        span[class*='icon-']:before {
            top: 4px;
            position: relative;
        }
    }

    ::v-deep .ada-table-container tr {
        display: flex;
    }

    ::v-deep .ada-table-container td {
        display: block;
    }

</style>